<template>
  <div class="container">
    <!-- <p>使用记录</p> -->

    <div class="head-color">
      <div class="head-content">
        <div class="head-content-title">
          <p class="head-title">流量使用概览</p>

          <img
            class="add-device-icon"
            @click="refresh"
            src="@/assets/images/home/frash.png"
          />
        </div>

        <div class="date-range">
          <p>统计截止({{ statisticTime }})</p>
        </div>

        <div class="user-list-item">
          <div
            class="user-list-item-cell"
            v-for="(item, index) in trafficPackageList"
            :key="index"
          >
            <p class="item-value">
              {{ item.value }}
              <span style="font-size: 14px; font-weight: normal">{{
                item.replace
              }}</span>
            </p>
            <p class="item-label">{{ item.title }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 流量使用曲线图 -->

    <div class="charts-container">
      <div class="charts-color-block"></div>
      <p class="charts-title">流量使用统计图</p>
    </div>

    <!-- 时间 -->

    <div class="time-container">
      <div
        class="time-day"
        :class="{ active: activeTime === 'D' }"
        @click="switchTime('day')"
      >
        日
      </div>
      <div
        class="time-week"
        :class="{ active: activeTime === 'W' }"
        @click="switchTime('week')"
      >
        周
      </div>
      <div
        class="time-month"
        :class="{ active: activeTime === 'M' }"
        @click="switchTime('month')"
      >
        月
      </div>
    </div>
    <charts :usage="usage" :xaxis="xaxis"></charts>
  </div>
</template>

<script>
import charts from "@/components/charts/index";
import { getFlowChart, getUserDeviceList, getFlowInfo } from "@/api/home";
import { Toast } from "vant";
export default {
  components: {
    charts,
  },
  data() {
    return {
      isLoading: false,

      statisticTime: "",

      trafficPackageList: [
        {
          title: "套餐周期",
          value: "--",
          replace: "",
        },
        {
          title: "单日总量",
          value: "--",
          replace: "",
        },
        {
          title: "当日剩余",
          value: "--",
          replace: "",
        },
      ],

      activeTime: "D", // 默认选中"日"，使用后端枚举值 D/W/M
      deviceID: "", // 添加设备ID

      //统计时间
      startDate: "",
      endDate: "",
      //本月套餐
      monthFlow: 0,
      monthBuy: 0,
      monthSurplus: 0,
      // 流量使用统计图
      usage: [],
      xaxis: [],
    };
  },

  mounted() {
    this.deviceID = this.$route.query.id;
    if (this.deviceID) {
      this.getUseFlowInfoAction();
      this.getFlowChartAction();
    } else {
      this.getUserDeviceListAction();
    }
  },

  methods: {
    ///获取设备列表
    getUserDeviceListAction() {
      // 设置加载状态
      this.isLoading = true;

      getUserDeviceList()
        .then((res) => {
          // 转换设备列表数据
          this.deviceList = res.map((item) => ({
            id: item.id,
            modelName: item.modelName,
            sn: item.sn,
            picUrl: item.picUrl,
          }));

          // 处理设备ID
          const checkID = this.$store.getters.getDeviceID;
          // 检查保存的设备ID是否在当前设备列表中
          if (this.deviceList.length > 0) {
            let selectDevice = this.deviceList.find(
              (device) => device.id === checkID
            );

            if (!selectDevice) {
              selectDevice = this.deviceList[0];
            }

            if (selectDevice) {
              this.deviceID = selectDevice.id;

              this.getUseFlowInfoAction();
              this.getFlowChartAction();
            }
          }
        })
        .catch((error) => {
          this.isLoading = false;
        });
    },

    switchTime(type) {
      // 转换前端显示值为后端枚举值
      const typeMap = {
        day: "D",
        week: "W",
        month: "M",
      };
      this.activeTime = typeMap[type];
      this.getFlowChartAction();
    },

    // 获取流量使用统计图
    getFlowChartAction() {
      if (!this.deviceID) {
        return;
      }

      getFlowChart({
        terminalId: this.deviceID,
        dateRange: this.activeTime, // 枚举备注: D:日 W:周 M:月
      })
        .then((res) => {
          if (res && res.usage && res.xaxis) {
            this.usage = res.usage;
            this.xaxis = res.xaxis;

            if (this.activeTime === "D") {
              // 返回数据 2025.03.08 去掉年份
              this.xaxis = this.xaxis.map((item) => {
                let x = item.split(".");
                return x[1] + "." + x[2];
              });
            } else if (this.activeTime === "W") {
              // 2025.02.10-2025.02.16  先根据 - 分割 然后 再根据 . 分割
              this.xaxis = this.xaxis.map((item) => {
                let x = item.split("-");
                let x1 = x[0].split(".");
                let x2 = x[1].split(".");
                return x1[1] + "." + x1[2] + "-" + x2[1] + "." + x2[2];
              });
            } else if (this.activeTime === "M") {
              this.xaxis = res.xaxis;
            }
          }
        })
        .catch((error) => {
          console.error("获取流量使用统计图失败:", error);
        });
    },

    ///获取流量使用信息
    getUseFlowInfoAction() {
      this.isLoading = true;
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });

      getFlowInfo({
        id: this.deviceID,
      })
        .then((res) => {
          this.statisticTime = res.statisticTime.replace(/-/g, ".");

          let type = res.packageCycleUnit;
          let typeValue = res.packageCycleValue;

          if (type === "L") {
            this.trafficPackageList = [
              {
                title: "总量",
                value: res.totalTraffic,
                replace: "GB",
              },
              {
                title: "剩余",
                value: res.remainTraffic,
                replace: "GB",
              },
            ];
          } else {
            let replace = "";

            if (type === "M") {
              type = "月";
              replace = "个月";
            } else {
              type = "天";
              replace = "天";
            }

            this.trafficPackageList = [
              {
                title: "套餐周期",
                value: typeValue,
                replace: replace,
              },
              {
                title: "单" + type + "总量",
                value: res.totalTraffic,
                replace: "GB",
              },
              {
                title: "当" + type + "剩余",
                value: res.remainTraffic,
                replace: "GB",
              },
            ];
          }
        })
        .catch((error) => {
          this.isLoading = false;
          console.error("获取首页流量使用信息失败:", error);
        });
    },

    // 刷新本月的使用情况
    refresh() {
      this.getUseFlowInfoAction();
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
}

.head-color {
  height: 410px;
  background-color: #c3b19c;
}

.head-content {
  margin-left: 32px;
  margin-right: 32px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.8) 0%,
    #ffffff 100%
  );
  border-radius: 20px;
  border: 2px solid #ffffff;
  position: relative;
  top: 40px;
  padding-bottom: 48px;
}

.head-content-title {
  display: flex;
  align-items: center; /* 水平对齐 */
  justify-content: center; /* 居中对齐 */
  position: relative; /* 使绝对定位的元素相对于此容器 */
}

.head-title {
  font-size: 32px;
  font-weight: 700;
  color: var(--text-color);
  margin-bottom: 0; /* 移除下边距 */
}

.add-device-icon {
  width: 32px;
  height: 32px;
  position: absolute; /* 绝对定位 */
  right: 30px; /* 距离右边15px */
}

.date-range {
  font-size: 24px;
  color: var(--text-sub-color);
  display: flex;
  align-items: center;
  justify-content: center;
}

.user-list-item {
  display: flex;
  justify-content: space-between; /* 均分空间 */
  flex: 1;
}

.user-list-item-cell {
  flex: 1; /* 均分 */
  text-align: center; /* 内容居中对齐 */
}

.item-value {
  font-size: 40px;
  font-weight: bold;
  color: #333333;
  margin-bottom: 8px;
}

.item-label {
  font-size: 28px;
  color: var(--text-sub-color);
  margin-bottom: 0px;
  margin-top: 0px;
}

.charts-container {
  display: flex;
  align-items: center;
  margin-bottom: 0px;
}

.charts-color-block {
  width: 8px;
  height: 24px;
  background-color: var(--primary-color);
  border-radius: 4px;
  margin-left: 30px;
}

.charts-title {
  font-size: 32px;
  font-weight: 700;
  color: var(--text-color);
  margin-left: 10px;
}

.time-container {
  display: flex;
  align-items: center;
  margin: 36px auto 40px;
  width: 480px;
  border-radius: 32px;
  background-color: var(--line-color);
}

.time-day,
.time-week,
.time-month {
  font-size: 28px;
  width: 160px;
  height: 64px;
  text-align: center;
  line-height: 64px;
  background-color: var(--line-color);
  color: var(--text-sub-color);
  cursor: pointer;
  transition: all 0.3s ease;

  &.active {
    background-color: var(--primary-color);
    color: #ffffff;
    border-radius: 32px;
  }
}

.time-day {
  border-radius: 32px 0 0 32px;
}

.time-month {
  border-radius: 0 32px 32px 0;
}
</style>
